import { render, staticRenderFns } from "./chart-garbage-calculation.vue?vue&type=template&id=72e51c60&"
import script from "./chart-garbage-calculation.vue?vue&type=script&lang=js&"
export * from "./chart-garbage-calculation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports